// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.edit-modal[data-v-22f90be8] {\n  padding-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
